<div class="popup-container">

<header>
    <label class="close_button" (click)="close()">x</label>
    <div class="header d-block roboto-medium">
        <label class="ms-3 mt-3 mb-3">{{heading}}</label>
    </div>
</header>
<div class="mt-3 ms-3 mb-3">
    <div class="mb-3 me-3 d-flex justify-content-between">
        <div>
            <label class="drpdwn_period_label">Logistics Point</label>
            <select [(ngModel)]="planName" [ngModelOptions]="{standalone: true}" (change)="onLPchange()"
                class="drpdwn_period ms-3">
                <option *ngFor="let eachplantList of plantList" [value]="eachplantList.position">
                    {{eachplantList.description}}
                </option>
            </select>
        </div>
        <div>
            <label class="drpdwn_period_label lab">Last updated by:</label>
            <label class="drpdwn_period_label ms-2">{{lastUpdatedBy}}</label>
            <label class="drpdwn_period_label ms-5 lab" >Last updated date:</label>
            <label class="drpdwn_period_label ms-2">{{lastUpdatedAt}}</label>
        </div>
    </div>
    <div class="px-3" *ngIf="successMessage!=null" class="alert alert-success alert-dismissible fade show p-2 ms-4 me-4" role="alert">
    
        <button type="button" class="btn-close" (click)="closeNotification()" data-bs-dismiss="alert" aria-label="close"></button>
        <strong>{{successMessage}}</strong>
    </div>
    <div class="px-3" *ngIf="errorMessage!=null" class="alert alert-danger alert-dismissible fade show p-2 ms-4 me-4" role="alert">
        
        <button type="button" class="btn-close" (click)="closeNotification()" data-bs-dismiss="alert" aria-label="close"></button>
        <strong>{{errorMessage}}</strong>
    </div>
    <!-- <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
    </app-notification-message> -->
    <ag-grid-angular
        class="ag-theme-balham grid-items update_criteria_comp" (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()" [animateRows]="true"
        [defaultColDef]="defaultColDef" [columnDefs]="columnDef" [rowData]="displayRowData" [context]="context"
        [icons]="icons" [rowClassRules]="rowClassRules">
    </ag-grid-angular>
    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
    
</div>
<div class="footer d-flex justify-content-end align-items-center fixed-bottom mt-2 pt-2 pb-2">
    <button class="cancel me-3 roboto-bold" (click)="close()"> CANCEL </button>
    <button class="submit black-button me-3 roboto-medium" (click) = "update()">UPDATE</button>
</div>
</div>